var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Sfumatura_senza_nome_3);\n      }\n\n      .st1 {\n        fill: #bad043;\n      }\n\n      .st2 {\n        fill: #19233e;\n      }\n\n      .st3 {\n        fill: none;\n        stroke: #19233e;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 35px;\n      }\n\n      .st4 {\n        fill: #0075be;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3",
    "data-name": "Sfumatura senza nome 3",
    x1: 221.3,
    y1: -173.7,
    x2: 221.3,
    y2: 164.4,
    gradientTransform: "translate(0 252.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbd143"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312,352.2l10.3-22.5,15.7-19.3,13.8-9.9,17.2-7.3,15.3-4.6,17.1-1.9h17.4l14,3.5V110.5c0-17.7-16.1-32.1-36-32.1H45.7c-19.9,0-36,14.4-36,32.2v273.8c0,17.7,16.1,32.1,36,32.1h270.8l-8.8-38,4.2-26.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.1,67v39M339.8,67.3v39.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M397.7,76.9H43.9c-19.9,0-36.2,14.3-36.3,32.2v41.8h426.4v-41.8c0-17.7-16.3-32.2-36.3-32.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.5,371.7h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M240.6,371.4h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.1,322.2h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M241.2,321.9h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.4,270.3h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.2,270h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M240.3,269.7h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M362,220.8h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.8,220.5h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M240.9,220.2h-43.7c-6.4,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h43.7c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341,299.5h-22.3c-6.4,0-11.5,5.1-11.5,11.5s5.1,11.5,11.5,11.5h.3c6-8.8,13.5-16.6,22-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M366.5,300.3c10.5-4.6,22.1-7.2,34.3-7.2s20.7,1.9,30.3,5.5c.8.3,1.6.4,2.4.4,2.8,0,5.4-1.7,6.4-4.4,1.3-3.5-.4-7.5-4-8.8-11.2-4.3-23.1-6.4-35.2-6.4-22.5,0-43.2,7.5-59.8,20.1h21.4c1.4,0,2.8.3,4.1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M489.4,333.9c-1.7-3.4-5.8-4.7-9.2-3-3.4,1.7-4.7,5.8-3,9.2,6.1,12,9.1,24.9,9.1,38.5,0,47.2-38.4,85.5-85.5,85.5s-85.5-38.4-85.5-85.5,7.9-41,21-56h-17.3c-11,16-17.4,35.3-17.4,56,0,54.7,44.5,99.2,99.2,99.2s99.2-44.5,99.2-99.2-3.6-30.7-10.6-44.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M366.5,300.3c-1.3-.5-2.6-.8-4.1-.8h-21.4c-8.5,6.4-15.9,14.2-22,23h17.3c8.2-9.5,18.5-17.1,30.2-22.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.5,387.8l-37.4-39.3c-2.6-2.7-6.9-2.8-9.7-.2-2.7,2.6-2.8,6.9-.2,9.7l39.4,41.4c0-.4,0-.8,0-1.2,0-4.9,3.4-9.1,8-10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400,390.2c-4.3,0-7.8,3.5-7.8,7.8s3.5,7.8,7.8,7.8,7.8-3.5,7.8-7.8-3.5-7.8-7.8-7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465,307.1c-3.1-2.1-7.4-1.3-9.5,1.8l-54,78.8c5.1.7,9.1,5.1,9.1,10.4s0,.3,0,.5l56.2-81.9c2.1-3.1,1.3-7.4-1.8-9.5Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bcbc5c2dc2da70e39e4feb0ada3447ad.svg";
export { ForwardRef as ReactComponent };